import script from '../../templates/cookie-consent.js';

export default class CookieConsent {
  static inject() {
    $('head').append(script);
  }
}
